var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-page',{attrs:{"id":'page-' + _vm.app_name,"image_source":_vm.image_source,"image_height":_vm.image_height,"main_filters":_vm.main_filters,"title":_vm.ota}},[_c(_vm.app_name,{ref:_vm.app_name,tag:"component",attrs:{"ota":_vm.ota}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }